<template>

    <swiper :options="swiperOption" class="swiper-box" ref="mySwiper">
        <swiper-slide class="swiper-item -align-center">
            <img src="@/images/slogan_studio.svg" class="slogan-img"/>
            
            <span class="triangle -red-triangle"></span>
            <!--div class="divider-bottom -red-divider"></div-->
        </swiper-slide>

        <swiper-slide class="swiper-item -align-center">
            <div class="studio-container ">
                <Row type="flex" justify="center" align="middle">
                    <Col :xs="24" :sm="24" :md="12">
                        <div class="studio-intro-body">
                            <div class="studio-intro-header">
                                <div class="studio-header">
                                    <h2>我们可以做</h2>
                                </div>
                            </div>
                            <div class="studio-intro-nav">
                                <h2 class="studio-intro-nav-item-text">
                                    Web / APP / 服务器端开发
                                </h2>
                            </div>

                            <div class="studio-intro-description">
                                <div class="studio-text">
                                    <p>敏捷高效的团队, 具有扎实的设计和开发专业知识。我们为初创企业打造移动互联网产品，并设计完善相应的商业模式, 品牌构建。</p>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col :xs="24" :sm="24" :md="12">
                        <img src="@/images/tech.png"  class="tech-cover">
                    </Col>
                </Row>
            </div>
            <div class="studio-intro-more" @click="handleNext">
                <b>项目案例</b>
                <span></span>
            </div>
            <div class="divider-bottom -blue-divider"></div>
        </swiper-slide>

        <swiper-slide class="swiper-item -align-center">
            <div class="studio-container">
                <Row type="flex" justify="center"  align="middle">
                     <Col :xs="24" :sm="24" :md="12">
                        <div class="studio-intro-body">
                            <div class="studio-intro-header">
                                <div class="studio-header">
                                    <h2>当家花旦</h2>
                                </div>
                            </div>
                            <div class="studio-intro-nav">
                                <h2 class="studio-intro-nav-item-text">
                                    野醺 <sup>®</sup>
                                </h2>
                            </div>

                            <div class="studio-intro-description">
                                <div class="studio-text">
                                    <p>专注出品适合新手的零失败鸡尾酒调酒教程。</p>
                                    <p class="-text-sm">整个产品涵盖了高并发API服务器，web客户端，iOS及Android客户端，配套媒体矩阵运营工具。从原型设计，品牌构建，设计开发，整套方案历时8个月，拥有完备的商标和版权，由团队倾力打造。</p>
                                </div>
                            </div>
                        </div>
                    </Col>

                    <Col :xs="24" :sm="24" :md="12">
                        <img src="@/images/iPhone_show.png"  class="tech-cover">
                    </Col>
                </Row>
            </div>
            <a class="studio-intro-more" role="button" href="https://beastush.com" target="_blank">
                <b>线上体验</b>
                <span></span>
            </a>
            <div class="divider-bottom -blue-divider"></div>
        </swiper-slide>

        <swiper-slide class="swiper-item -align-center">
            
            <Row type="flex" justify="center" align="top">
                <Col :xs="24" :sm="24" :md="12">
                    <div class="studio-container">
                        <div class="studio-intro-body -contract">
                            <div class="studio-intro-nav">
                                <h3 class="studio-intro-nav-item-text">我们是谁?</h3>
                            </div>

                            <div class="studio-intro-description">
                                <div class="studio-text">
                                    <p>「不工@icodezign」是一个善于将设计与技术结合的年轻团队，可以在网络和移动应用程序开发领域接受任何挑战。团队主要成员来自于清华大学, 北京航空航天大学, 具有丰富的项目经验和扎实的技术能力。我们从不走捷径，与时俱进，始终坚持设计和开发的最新趋势。</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col :xs="24" :sm="24" :md="12">
                    <div class="studio-container">
                        <div class="studio-intro-body -contract">
                            <div class="studio-intro-nav">
                                <h3 class="studio-intro-nav-item-text">联系我们</h3>
                            </div>
                            <div class="email-form">

                                <BlankInput  class="email-input"
                                          placeholder="姓名" 
                                          v-model="sender" />
                                <BlankInput  class="email-input"
                                          placeholder="邮箱" 
                                          v-model="account" />
                                <BlankInput  class="email-input"
                                          placeholder="您的需求" 
                                          v-model="content" />

                                <a class="studio-btn_view" role="button"  @click="handleSend">
                                    <b class="studio-btn_view-text">发送邮件</b>
                                    <span class="studio-btn_view-line"></span>
                                </a>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>

            <div  class="studio-footer">
                <Row type="flex" justify="center" align="middle">
                    <Col :xs="24" :sm="24" :md="24">
                        <div class="cb-footer-left">
                            <a class="cb-social-item" href="https://weibo.com/u/2197798463" target="_blank">
                                <span class="cb-social-item-text"><span>微博</span></span>
                            </a>
                            <a class="cb-social-item" href="https://zhuanlan.zhihu.com/c_1248709906712379392" target="_blank">
                                <span class="cb-social-item-text"><span>知乎</span></span>
                            </a>
                            <a class="cb-social-item" href="https://github.com/zouyiran1988/beastush" target="_blank">
                                <span class="cb-social-item-text"><span>github</span></span>
                            </a>
                            <a class="cb-social-item" href="https://dribbble.com/zouyiran" target="_blank">
                                <span class="cb-social-item-text"><span>Dribbble</span></span>
                            </a>
                        </div>
                    </Col>
                    <!--Col :xs="24" :sm="24" :md="12"></Col-->
                </Row>

                <div class="beian-rights">
                    <span>© 2020 不工 </span>
                   
                    <a href="https://beian.miit.gov.cn/" target="_blank" class="studio-gov-info" >
                        津ICP备19000583号-3
                    </a>
             
                    <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=12011602000322" class="studio-gov-info" >
                            <img :src="gongan_beian">
                            津公网安备 12011602000322号
                    </a>

                </div>
            </div>
            
        </swiper-slide>


    </swiper>

</template>

<script>
// 微信
import wx from 'weixin-js-sdk'
// 发送客服邮件
import { serviceHelper, serviceWechatJSAPI} from '@/services/api'
import api from '@/services/api-config';
// 处理静态资源的无奈之举
import img_1 from '@/images/iPhone_show.png'
import img_gongan from '@/images/gongan.png'
import logo from '@/images/logo_bugong.jpg'
export default {
    data() {
        return {
            page_links: '',
            page_thumb: '',
            swiperOption: {
                direction: 'vertical',
                slidesPerView: 1,
                spaceBetween: 0,
                mousewheel: true,
                //keyboardControl: true,
                //nextButton: '.nextButton',
            },

            helperType: 'STUDIO',
            account: '',
            sender: '',
            content: '',
            gongan_beian: img_gongan
        }
    },

    mounted () {
        this.page_links = window.location.href.split('#')[0];
        this.page_thumb = api.imageRootUrl + logo.trim();
        this.getWechatJSAPI();
    },
    computed: {
        coverImgStyles () {
            //let randomNum = randomInt(0, 7);
            let style = {};
    
            //let custom = `/static/home_cover_${randomNum}.jpeg`
            //let list = [img_1, img_2, img_3, img_4, img_5, img_6, img_7, img_8]
            //console.log(randomNum)
            //let cover = list[randomNum]
            let cover = img_1
            style['background-image'] = `url(${cover})`;
            return style;
        },
    },

    methods: {

        showLoading() {
            //this.$Toast.success({ content: '发送成功'});
            //this.$Toast.error({ content: '发送失败'});
            //this.$Toast.loading({ content: '正在发送'});

            this.$Loading.show()
            
        },
        hideLoading() {
            this.$Loading.hide();         
        },

        handleSend(){ 
            // this.showLoading()
            serviceHelper({ account: this.account, 
                            sender: this.sender, 
                            content: this.content, 
                            helper_type: this.helperType
                        })
            .then(response => {
                //console.log(response.data.res.posts)
                //this.posts = this.posts.concat(response.data.res.posts);
                if(response.data.code == 0) {
                    this.$Toast.success({ content: '发送成功' });
                } else {
                    this.$Toast.error({ content: '发送失败'});
                }
                
            })
        },
        
        handleNext(){
            this.$refs.mySwiper.swiper.slideNext();
        },

        // 获取微信中的相关参数
        getWechatJSAPI() {
        
            //encodeURIComponent(window.location.href.split('#')[0])
            serviceWechatJSAPI({ url: encodeURIComponent(window.location.href.split('#')[0]) })
            .then(response => {
                /*
                console.log(response.data.res.appId)
                console.log(response.data.res.timestamp)
                console.log(response.data.res.nonceStr)
                console.log(response.data.res.signature)
                */
                wx.config({
                    debug: false,
                    appId: response.data.res.appId,
                    timestamp: response.data.res.timestamp,
                    nonceStr: response.data.res.nonceStr,
                    signature: response.data.res.signature,
                    jsApiList: [
                        'checkJsApi',//必填，检测api是否有权限
                        'updateAppMessageShareData',
                        'updateTimelineShareData',
                        //'onMenuShareAppMessage',
                        //'onMenuShareTimeline',
                    ]
                })

                let links = this.page_links;
                let imgUrl = this.page_thumb;
                
                wx.ready(() => {

                    let shareData = {
                        title: '不工 - 作品集', // 分享标题
                        desc:'设计不止是表现，程序不止是代码',
                        link: links, 
                        imgUrl: imgUrl, // 分享图标需要绝对路径
                    }


                    //分享到微信好友或者qq好友
                    wx.updateAppMessageShareData(shareData);
                    //分享到朋友圈或者qq空间
                    wx.updateTimelineShareData(shareData);
                    //分享失败打印
                    //wx.error(function(res) { alert(res.errMsg); });
                    /*
                    //这一步是验证接口权限
                    wx.checkJsApi({
                        jsApiList: ['onMenuShareTimeline','onMenuShareAppMessage'],
                        success:function(res){
                            console.log(res)
                        },
                        error:function(err){
                            console.log(err)
                        }
                    }); 
                    // 微信分享给朋友
                    wx.updateAppMessageShareData({
                        title: optionApp.title, // 分享标题
                        link: optionApp.link, // 分享链接
                        imgUrl: optionApp.imgUrl, // 分享图标
                        desc: optionApp.desc, // 分享图标
                        // 成功分享
                        success(){},
                        // 用户取消分享后执行的回调函数
                        cancel(){},
                        // alert("分享失败！"+JSON.stringify(s));
                        fail(){}
                    }),

                    // 微信分享到朋友圈
                    wx.updateTimelineShareData({
                        title: optionTimeline.title, // 分享标题
                        link: optionTimeline.link, // 分享链接
                        imgUrl: optionTimeline.imgUrl, // 分享图标
                        desc:optionTimeline.desc,
                        success(){},
                        cancel(){},
                        fail(){}
                    })
                    */
                })

            })
        }
        
    }
  }
</script>